import { render, staticRenderFns } from "./CreateBlendSettingsDialog.vue?vue&type=template&id=3e074345&scoped=true"
import script from "./CreateBlendSettingsDialog.vue?vue&type=script&lang=js"
export * from "./CreateBlendSettingsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e074345",
  null
  
)

export default component.exports